import request from "@/utils/request";

// 获取赛道
export function getTrack(data) {
    return request({
        url: `/match/track/getTracks/${data}`,
        method: "get",
    });
}

// 获取分组
export function getTag(data) {
    return request({
        url: `/match/matchTag/list`,
        method: "post",
        data
    });
}


// 获取表单
export function getFrom(data) {
    return request({
        url: `/match/matchForm/info`,
        method: "post",
        data
    });
}

// 提交表单
export function addFrom(data) {
    return request({
        url: `/match/item/add`,
        method: "post",
        data
    });
}

// 修改表单
export function updataFrom(data) {
    return request({
        url: `/match/item/update`,
        method: "post",
        data
    });
}

// 查看作品
export function getInfo(params) {
    return request({
        url: `/match/item/info/${params}`,
        method: "get"
    });
}
//存储断点续传信息
export function setUuid(data){
    return request({
        url:'support/upYun/newBreakpointResume',
        method:'post',  
        data
    })
}
//获取断点续传uuid
export function getUuid(data){
    return request({
        url:  `support/upYun/taskInfo/${data}`,
        method:'get',
    })
}

//又拍云验证
export async function getTokenUrl(data){
	let url = await changeUrl(data) 
	let newurl = url.data
	return newurl

}
 
export function changeUrl(url){
	return request({
		url:`support/upYun/getTokenUrl?pathUrl=${url}`,
		method:'get'
	})
}

// 获取排序
export function getSort(data) {
    return request({
        url: `/match/item/getSort`,
        method: "post",
        data
    });
}


// WEBPACK FOOTER //
// ./src/api/uploading.js